import React from 'react';
import './TextBtn.sass';
import download_outline_28 from '../../images/download_outline_28.svg';

const TextBtn = ({href, text, type = 'green'}) => {
    return (
        <a
            href={href}
            className={`text-btn text-btn--${type}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className={'icon download'} style={{ backgroundImage: "url(" + download_outline_28 + ")" }} />
            <span className={'text-btn-text'}>{text}</span>
        </a>
    );
};

export default TextBtn;
